module.exports = __webpack_public_path__ + "img/chart-line.f997affe.png";